<div class="">
  <div class="border-2 border-gray-200 rounded-lg">
    <div class="overflow-hidden bg-white border border-gray-200 rounded-lg shadow-sm">
      <div class="flex flex-wrap items-center justify-between gap-4 px-4 py-2 bg-gray-50/50 border-b border-gray-200">
        
        <div class="flex items-center gap-3">
          <div class="flex items-center justify-center w-8 h-8 bg-blue-100 rounded-md">
            <i class="text-sm pi pi-database text-blue-600"></i>
          </div>
          <h2 class="text-lg font-bold tracking-tight text-gray-900">{{ title }}</h2>
        </div>
    
        <div class="flex items-center flex-1 gap-2 ml-auto justify-end">
          
          <div *ngIf="showSearch" class="relative w-full max-w-xs transition-all focus-within:max-w-sm">
            <i class="absolute text-gray-400 pi pi-search left-3 top-1/2 -translate-y-1/2 text-xs"></i>
            <input
              #searchInput
              type="text"
              [(ngModel)]="searchText"
              (keyup.enter)="onEnterSearch(searchText)"
              placeholder="Search..."
              class="w-full py-1.5 pl-9 pr-4 text-sm bg-white border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none transition-all"
            />
          </div>
    
          <div class="w-px h-6 mx-1 bg-gray-300"></div>
    
          <div class="flex items-center gap-1.5">
            <ng-container *ngFor="let button of additionalHeaderButtons">
              <button 
                type="button"
                (click)="onAdditionalButtonClick.emit(button.action)"
                [pTooltip]="button.label"
                tooltipPosition="top"
                class="inline-flex items-center gap-2 px-3 py-1.5 text-xs font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 active:bg-gray-100 transition-colors shadow-sm">
                <i *ngIf="button.icon" [class]="button.icon + ' text-[10px] text-gray-500'"></i>
                <span class="hidden sm:inline">{{ button.label }}</span>
              </button>
            </ng-container>
    
            <button
              *ngIf="searchText"
              type="button"
              (click)="clear(dt)"
              class="inline-flex items-center gap-2 px-3 py-1.5 text-xs font-medium text-red-600 bg-white border border-red-200 rounded-md hover:bg-red-50 transition-colors">
              <i class="pi pi-filter-slash text-[10px]"></i>
              <span class="hidden sm:inline">Clear</span>
            </button>
    
            <button 
              *ngIf="isCardView"
              type="button"
              (click)="onPresentView.emit(true)"
              class="inline-flex items-center gap-2 px-3 py-1.5 text-xs font-medium text-indigo-700 bg-indigo-50 border border-indigo-200 rounded-md hover:bg-indigo-100 transition-colors shadow-sm">
              <i class="pi pi-id-card text-[10px]"></i>
              <span class="hidden sm:inline">View</span>
            </button>
    
            <button 
              *ngIf="showAddButton"
              type="button"
              (click)="onAdd.emit()" 
              class="inline-flex items-center gap-2 px-3 py-1.5 text-xs font-bold text-white bg-blue-600 rounded-md hover:bg-blue-700 shadow-sm transition-all focus:ring-2 focus:ring-blue-500 focus:ring-offset-1">
              <i class="pi pi-plus text-[10px]"></i>
              <span>Add</span>
            </button>
          </div>
    
        </div>
      </div>
    </div>

    <!-- Table Section -->
    <p-table #dt 
      [columns]="columns" [value]="customers" 
      [rowHover]="true"
      [rows]="rowsPerPage"
      [showCurrentPageReport]="showCurrentPageReport"
      [rowsPerPageOptions]="rowsPerPageOptions"
      [paginator]="totalCount > 9"
      [lazy]="lazy"
      [totalRecords]="totalCount"
      [selectionMode]="selectionMode"
      [(selection)]="selectedItems"
      [currentPageReportTemplate]="'Showing {first} to {last} of {totalRecords} entries'"
      [scrollable]="true" 
      showGridlines="horizontal"
      styleClass="p-datatable-gridlines  overflow-hidden"
      resizableColumns="true" 
      columnResizeMode="expand" 
      (onPage)="onPageChange($event)"
      (onRowSelect)="onSelectionChange.emit(selectedItems)"
      (onRowUnselect)="onSelectionChange.emit(selectedItems)"
      dataKey="id">

      <!-- HEADER: Modern column design -->
      <ng-template pTemplate="header">
        <tr class="">
          <th *ngIf="showCheckbox">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th class="w-24 text-center" *ngIf="showActions">
            ACTIONS
          </th>
          <th *ngFor="let col of cols" 
              pReorderableColumn 
              [style.width]="getColumnWidth(col)"
              class="sortable-column"
              >
            <div class="flex items-center justify-between" (click)="this.lazy = false" >
              <div class="flex items-center gap-2"><p-sortIcon [field]="col.field" [pSortableColumn]="col.field" styleClass="custom-sort-icon"></p-sortIcon>
                <span class="text-wrap text-wrap-break">{{ col.header.toUpperCase() }}</span></div>
              <p-columnFilter class="text-gray-600" type="text" [showAddButton]="false" [field]="col.field" display="menu"/>
             
            </div>
            <!-- <p-sortIcon [field]="col.field"></p-sortIcon> -->
          </th>
        </tr>
      </ng-template>

      <!-- BODY: Modern row design -->
      <ng-template pTemplate="body" let-rowData let-index="rowIndex">
        <tr [pReorderableRow]="index">
          <td *ngIf="showCheckbox">
            <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
          </td>
          <td class="text-center" *ngIf="showActions">
            <button
              type="button"
              pButton
              label="Actions"
              [attr.aria-label]="'Open actions'"
              styleClass="p-button-text p-button-sm"
              (click)="currentRow = rowData"
              [matMenuTriggerFor]="actionMenu"
            >
            </button>
            <mat-menu #actionMenu="matMenu">
              <button 
                *ngIf="isView" 
                (click)="viewEventRow.emit(rowData)"
                class="flex items-center gap-2 px-4 py-2"
              >
                <i class="pi pi-eye text-blue-700 mr-2"></i> View
              </button>
              <button 
                *ngIf="isEditable" 
                (click)="editEventRow.emit(rowData)"
                class="flex items-center gap-2 px-4 py-2"
              >
                <i class="pi pi-pencil text-yellow-600 mr-2"></i> Edit
              </button>
              <button 
                mat-menu-item 
                *ngIf="isDeletable" 
                (click)="deleteEventRow.emit(rowData)"
                class="flex items-center gap-2 px-4 py-2"
              >
                <i class="pi pi-trash text-red-700 mr-2"></i> Delete
              </button>
            </mat-menu>
          </td>
          <td *ngFor="let col of cols" [style.width]="getColumnWidth(col)">
            <ng-container [ngSwitch]="true">
              <!-- Link type column -->
              <ng-container *ngSwitchCase="col.type === 'link'">
                <a 
                  [href]="apiUrl + getNestedValue(rowData, col.field)" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  View
                </a>
              </ng-container>
              <!-- Date fields -->
              <ng-container *ngSwitchCase="['created_on', 'updated_on'].includes(col.field)">
                {{ getNestedValue(rowData, col.field) | date:'dd MMM yy' }}
              </ng-container>
              <!-- Status field or header -->
              <ng-container *ngSwitchCase="col.field === 'status' || col.header === 'Status'">
                <p-tag 
                  [value]="getNestedValue(rowData, col.field)"
                  [severity]="getSeverity(getNestedValue(rowData, col.field))">
                </p-tag>
              </ng-container>
              <!-- Default display -->
             <!-- Documents column -->
<!-- Documents Column -->
<ng-container *ngSwitchCase="col.field === 'documents'">
  <i 
    class="pi pi-download text-blue-600 cursor-pointer text-lg"
    *ngIf="rowData.briefcase_files?.length"
    (click)="downloadFiles(rowData.briefcase_files)"
    pTooltip="Download Documents"
    tooltipPosition="top">
  </i>

  <span *ngIf="!rowData.briefcase_files?.length">-</span>
</ng-container>

<!-- Default display -->
<ng-container *ngSwitchDefault>
  {{ getNestedValue(rowData, col.field) }}
</ng-container>
            </ng-container>
          </td>
        </tr>
      </ng-template>

      <!-- EMPTY MESSAGE -->
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="cols.length + 1">
            <div class="flex flex-col items-center justify-center h-[30vh] w-full">
              <i class="pi pi-inbox text-5xl text-gray-400 mb-3"></i>
              <p class="text-lg text-gray-500 font-medium">No records found.</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>